<form [formGroup]="passwordForm" (ngSubmit)="onSubmit()"
  *ngIf="(!changeSuccess && passwordRecovery) || !passwordRecovery">
  <div class="flex flex-col gap-4 justify-center items-center">
    <p class="font-semibold">Change password</p>
    <div *ngIf="!passwordRecovery">
      <input type="password" id="oldPassword" formControlName="oldPassword"
        class="w-3xs rounded-lg border px-3 py-[calc(--spacing(2)-1px)] shadow-md shadow-zinc-800/5 placeholder:text-zinc-400 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden md:w-xs"
        placeholder="Enter old password" />
    </div>
    <div>
      <input type="password" id="password" formControlName="password"
        class="w-3xs rounded-lg border px-3 py-[calc(--spacing(2)-1px)] shadow-md shadow-zinc-800/5 placeholder:text-zinc-400 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden md:w-xs"
        placeholder="Enter new password" />
    </div>
    <div>
      <input type="password" id="password2" formControlName="newPassword"
        class="w-3xs rounded-lg border px-3 py-[calc(--spacing(2)-1px)] shadow-md shadow-zinc-800/5 placeholder:text-zinc-400 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden md:w-xs"
        placeholder="Enter new password" />
    </div>
    <div class="relative flex items-center">
      <button
        class="cursor-pointer justify-center rounded-lg bg-zinc-800 px-3 py-2 font-semibold text-zinc-100 outline-offset-2 transition hover:bg-zinc-700 active:bg-zinc-800 active:text-zinc-100/70 active:transition-none"
        type="submit">
        {{ passwordRecovery ? "Set Password" : "Reset Password" }}
      </button>
      <app-embedded-alert [error]="error" [success]="success" [persistSuccess]="true" class="ps-4"></app-embedded-alert>
    </div>
  </div>
</form>

<button
  class="cursor-pointer justify-center rounded-lg bg-zinc-800 px-3 py-2 font-semibold text-zinc-100 outline-offset-2 transition hover:bg-zinc-700 active:bg-zinc-800 active:text-zinc-100/70 active:transition-none"
  *ngIf="changeSuccess && passwordRecovery" (click)="goToLogin()">
  Go to Login
</button>